export enum NavStates {
  LoggedOutEmptyCart = 'loggedOutEmptyCart',
  LoggedOutNonEmptyCart = 'loggedOutNonEmptyCart',
  LoggedInEmptyCart = 'loggedInEmptyCart',
  LoggedInNonEmptyCart = 'loggedInNonEmptyCart',
}

const isHomepage = (asPath: string) => asPath.split(/[?#]/)[0] === '/';

// The homepage shows no nav CTA to logged-out empty carts; elsewhere they see Cart.
export const getNavCtas = (navState: NavStates, asPath: string) => {
  const loggedOutEmpty = navState === NavStates.LoggedOutEmptyCart;
  const onHomepage = isHomepage(asPath);

  return {
    showCart:
      navState === NavStates.LoggedOutNonEmptyCart ||
      navState === NavStates.LoggedInNonEmptyCart ||
      (loggedOutEmpty && !onHomepage),
  };
};

export const getNavState = (userState, userCart): NavStates => {
  const loggedIn = !!userState?.email;
  const cartEmpty = userCart.isEmpty();

  if (!loggedIn && cartEmpty) {
    return NavStates.LoggedOutEmptyCart;
  }

  if (!loggedIn && !cartEmpty) {
    return NavStates.LoggedOutNonEmptyCart;
  }

  if (loggedIn && cartEmpty) {
    return NavStates.LoggedInEmptyCart;
  }

  return NavStates.LoggedInNonEmptyCart;
};
